/**
 * 企业自定义字段权限管理API
 * PBI-8697: 企业自定义字段高级权限设置
 */
import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
/**
 * 查询默认权限
 */
export function getDefaultPermissionApi(field_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field-permission/default/get`,
        method: 'GET',
        params: {
            field_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 设置默认权限
 */
export async function setDefaultPermissionApi(request) {
    await psHttp({
        url: `${workspaceApiUrlPrefix}/field-permission/default/set`,
        method: 'POST',
        data: request,
        transformCode: true,
    });
}
/**
 * 查询字段权限配置（新版接口）
 */
export function searchFieldPermissionsApi(request) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field-permission/search`,
        method: 'POST',
        data: {
            field_id: request.fieldId,
            query: request.query,
            page: request.page,
            limit: request.limit,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 设置字段权限（新版批量接口）
 */
export async function setFieldPermissionsApi(request) {
    await psHttp({
        url: `${workspaceApiUrlPrefix}/field-permission/set`,
        method: 'POST',
        data: {
            permissions: request.permissions.map(permission => ({
                user_id: permission.user_id,
                field_id: permission.fieldId,
                permission_level: permission.permission_level,
            })),
        },
        transformCode: true,
    });
}
